export { LicensingService } from './lib/licensing.service';
